"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const DatahubModuleListTypes_1 = require("./DatahubModuleListTypes");
class DatahubModuleListService {
}
DatahubModuleListService.sendSearch = (label = '') => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category: DatahubModuleListTypes_1.ModuleListCategory.Search,
            action: constants_1.EVENTS_INTERACTIONS.SHOW,
            label
        })
    });
};
exports.default = DatahubModuleListService;
